import styled from "styled-components";

export const SocialNetworksStyles = styled.div`
    display:flex;
    align-items:center;
    ${props => props.mt && `margin-top:${props.mt};`}
`